import { formatDate } from "@/lib/format";
import { StatusBadge } from "@/components/status-badge";
import type { AccountTransactionDto } from "@/lib/clients-accounts";

export interface TransactionRowProps {
  tran: AccountTransactionDto;
  runningBalance: number;
}

const fmt = new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" });

export function TransactionRow({ tran, runningBalance }: TransactionRowProps) {
  const amountClass = tran.isCredit ? "text-green-700" : "text-red-700";
  return (
    <tr className={tran.deleted ? "opacity-50 line-through" : ""}>
      <td className="px-2 py-1">
        {formatDate(tran.transactionDate)}
      </td>
      <td className="px-2 py-1">
        <StatusBadge tone="info">{tran.tranTypeCode}</StatusBadge>
      </td>
      <td className="px-2 py-1">
        {tran.invoiceReferenceNo ? (
          <a className="underline" href={`/invoices/${tran.invoiceId}`}>
            {tran.invoiceReferenceNo}
          </a>
        ) : (
          "—"
        )}
      </td>
      <td className={`px-2 py-1 text-right ${amountClass}`}>
        {fmt.format(tran.tranAmount)}
      </td>
      <td className="px-2 py-1 text-right">{fmt.format(runningBalance)}</td>
      <td className="px-2 py-1 text-muted-foreground">{tran.comment ?? ""}</td>
    </tr>
  );
}
